import React from "react";

function AlgoFilters() {
  return (
    <main>
      {/* Breadcrumb Section */}
      <div className="row">
        <div className="col-md-6 col-sm-12 ">
          <div className="algo_strategies">
            {/* Header */}
            <div className="card_header">
              <h4 className="strategy_title">Nifty-ATM ±2 Straddle</h4>
              <div className="tags">
                <span className="tag new">New</span>
                <span className="tag nifty">Nifty</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
              {/* <div className="viewers">68+ viewers</div> */}
            </div>

            {/* Description */}
            <div className="card_body">
              <p className="strategy_desc">
                <a href="">
                  A Rolling Straddle is an options strategy where a trader
                  continuously shifts selling both a call and a put at the same
                  strike across different expiries or strikes to maintain
                  exposure while adapting to market movements
                </a>
              </p>
            </div>

            {/* Footer Metrics */}
            <div className="card_footer">
              <div className="metric">
                <span className="metric_label">Min Capital</span>
                <h6>₹1.40L</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Avg Return Backtest</span>
                <h6>--</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Status</span>
                <h6>Available</h6>
              </div>
              <div>
                <a href="/ExploreStrategy" class="btn_style_deploy">
                  Deploy
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 ">
          <div className="algo_strategies">
            {/* Header */}
            <div className="card_header">
              <h4 className="strategy_title">VWAP Bounce Option Buying</h4>
              <div className="tags">
                <span className="tag new">New</span>
                <span className="tag nifty">Nifty</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
              {/* <div className="viewers">68+ viewers</div> */}
            </div>

            {/* Description */}
            <div className="card_body">
              <p className="strategy_desc">
                <a href="">
                  VWAP Bounce Strategy for NIFTY Options. Enters on PDH/PDL
                  breakout with pullback to VWAP and confirmation candle. Uses
                  engulfing and pin bar patterns. 15% SL. Time windows:
                  9:30-11:00 AM and 1:30-2:45 PM.
                </a>
              </p>
            </div>

            {/* Footer Metrics */}
            <div className="card_footer">
              <div className="metric">
                <span className="metric_label">Min Capital</span>
                <h6>₹1.40L</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Avg Return Backtest</span>
                <h6>--</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Status</span>
                <h6>Available</h6>
              </div>
              <div>
                <a href="/ExploreStrategy" class="btn_style_deploy">
                  Deploy
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 ">
          <div className="algo_strategies">
            {/* Header */}
            <div className="card_header">
              <h4 className="strategy_title">CWA Nifty Option Buying</h4>
              <div className="tags">
                <span className="tag new">New</span>
                <span className="tag nifty">Nifty</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
              {/* <div className="viewers">68+ viewers</div> */}
            </div>

            {/* Description */}
            <div className="card_body">
              <p className="strategy_desc">
                <a href="">
                  An ATM option breakout strategy that monitors call and put
                  premiums, enters on a 30% upside move, applies a 50%
                  stop-loss, and allows one re-entry after stop-loss.
                </a>
              </p>
            </div>

            {/* Footer Metrics */}
            <div className="card_footer">
              <div className="metric">
                <span className="metric_label">Min Capital</span>
                <h6>₹1.40L</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Avg Return Backtest</span>
                <h6>--</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Status</span>
                <h6>Available</h6>
              </div>
              <div>
                <a href="/ExploreStrategy" class="btn_style_deploy">
                  Deploy
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 ">
          <div className="algo_strategies">
            {/* Header */}
            <div className="card_header">
              <h4 className="strategy_title">VWAP + 9 EMA Option Buying</h4>
              <div className="tags">
                <span className="tag new">New</span>
                <span className="tag nifty">Nifty</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
              {/* <div className="viewers">68+ viewers</div> */}
            </div>

            {/* Description */}
            <div className="card_body">
              <p className="strategy_desc">
                <a href="">
                  A VWAP + 9 EMA option buying strategy for NIFTY Options.
                  Enters on PDH/PDL breakout with pullback to VWAP and
                  confirmation candle. Uses engulfing and pin bar patterns. 15%
                  SL. Time windows: 9:30-11:00 AM and 1:30-2:45 PM.
                </a>
              </p>
            </div>

            {/* Footer Metrics */}
            <div className="card_footer">
              <div className="metric">
                <span className="metric_label">Min Capital</span>
                <h6>₹1.40L</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Avg Return Backtest</span>
                <h6>--</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Status</span>
                <h6>Available</h6>
              </div>
              <div>
                <a href="/ExploreStrategy" class="btn_style_deploy">
                  Deploy
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 ">
          <div className="algo_strategies">
            {/* Header */}
            <div className="card_header">
              <h4 className="strategy_title">Nifty-ATM ±2 Straddle</h4>
              <div className="tags">
                <span className="tag new">New</span>
                <span className="tag nifty">Nifty</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
              {/* <div className="viewers">68+ viewers</div> */}
            </div>

            {/* Description */}
            <div className="card_body">
              <p className="strategy_desc">
                <a href="">
                  A Rolling Straddle is an options strategy where a trader
                  continuously shifts selling both a call and a put at the same
                  strike across different expiries or strikes to maintain
                  exposure while adapting to market movements
                </a>
              </p>
            </div>

            {/* Footer Metrics */}
            <div className="card_footer">
              <div className="metric">
                <span className="metric_label">Min Capital</span>
                <h6>₹1.40L</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Avg Return Backtest</span>
                <h6>--</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Status</span>
                <h6>Available</h6>
              </div>
              <div>
                <a href="/ExploreStrategy" class="btn_style_deploy">
                  Deploy
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 ">
          <div className="algo_strategies">
            {/* Header */}
            <div className="card_header">
              <h4 className="strategy_title">VWAP Bounce Option Buying</h4>
              <div className="tags">
                <span className="tag new">New</span>
                <span className="tag nifty">Nifty</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
              {/* <div className="viewers">68+ viewers</div> */}
            </div>

            {/* Description */}
            <div className="card_body">
              <p className="strategy_desc">
                <a href="">
                  VWAP Bounce Strategy for NIFTY Options. Enters on PDH/PDL
                  breakout with pullback to VWAP and confirmation candle. Uses
                  engulfing and pin bar patterns. 15% SL. Time windows:
                  9:30-11:00 AM and 1:30-2:45 PM.
                </a>
              </p>
            </div>

            {/* Footer Metrics */}
            <div className="card_footer">
              <div className="metric">
                <span className="metric_label">Min Capital</span>
                <h6>₹1.40L</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Avg Return Backtest</span>
                <h6>--</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Status</span>
                <h6>Available</h6>
              </div>
              <div>
                <a href="/ExploreStrategy" class="btn_style_deploy">
                  Deploy
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 ">
          <div className="algo_strategies">
            {/* Header */}
            <div className="card_header">
              <h4 className="strategy_title">CWA Nifty Option Buying</h4>
              <div className="tags">
                <span className="tag new">New</span>
                <span className="tag nifty">Nifty</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
              {/* <div className="viewers">68+ viewers</div> */}
            </div>

            {/* Description */}
            <div className="card_body">
              <p className="strategy_desc">
                <a href="">
                  An ATM option breakout strategy that monitors call and put
                  premiums, enters on a 30% upside move, applies a 50%
                  stop-loss, and allows one re-entry after stop-loss.
                </a>
              </p>
            </div>

            {/* Footer Metrics */}
            <div className="card_footer">
              <div className="metric">
                <span className="metric_label">Min Capital</span>
                <h6>₹1.40L</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Avg Return Backtest</span>
                <h6>--</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Status</span>
                <h6>Available</h6>
              </div>
              <div>
                <a href="/ExploreStrategy" class="btn_style_deploy">
                  Deploy
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 ">
          <div className="algo_strategies">
            {/* Header */}
            <div className="card_header">
              <h4 className="strategy_title">VWAP + 9 EMA Option Buying</h4>
              <div className="tags">
                <span className="tag new">New</span>
                <span className="tag nifty">Nifty</span>
                <span className="tag intraday">Intraday</span>
                <span className="tag medium">Medium</span>
              </div>
              {/* <div className="viewers">68+ viewers</div> */}
            </div>

            {/* Description */}
            <div className="card_body">
              <p className="strategy_desc">
                <a href="">
                  A VWAP + 9 EMA option buying strategy for NIFTY Options.
                  Enters on PDH/PDL breakout with pullback to VWAP and
                  confirmation candle. Uses engulfing and pin bar patterns. 15%
                  SL. Time windows: 9:30-11:00 AM and 1:30-2:45 PM.
                </a>
              </p>
            </div>

            {/* Footer Metrics */}
            <div className="card_footer">
              <div className="metric">
                <span className="metric_label">Min Capital</span>
                <h6>₹1.40L</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Avg Return Backtest</span>
                <h6>--</h6>
              </div>
              <div className="metric">
                <span className="metric_label">Status</span>
                <h6>Available</h6>
              </div>
              <div>
                <a href="/ExploreStrategy" class="btn_style_deploy">
                  Deploy
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default AlgoFilters;
